module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-button-control"
  }, [_c('div', {
    staticClass: "switch-button",
    class: {
      enabled: _vm.isEnabled
    },
    style: ({
      '--color': _vm.color
    }),
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "switch-button-label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-908a84c6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/switch-button.vue
// module id = h1y0
// module chunks = 1